
enum httpValidationErrorCodes {
  required = 'required',
  fitInto = 'fitInto'
}

export const errorTitle = 'An error occurred';
export const unknownError = 'Unknown error code: ';

export enum httpValidationErrorMessages {
  tooManyResults = 'The number of search results exceeded the upper limit. Please edit your search.',

  required = 'is required',
  notBlank = 'is required',

  didNotPurchaseNotAllowed = 'DID NOT PURCHASE report is not allowed. There exists a purchase.',
  didNotPurchaseWeeklyBinNotFound = 'Weekly Report doesn\'t exist.',
  didNotPurchaseAlreadySubmitted = 'DID NOT PURCHASE report has been entered for this week.',

  doesNotMatchMarketType = 'The report type should match market types.',

  updatePurchaseNotAllowed = 'You are not allowed to update this purchase report.',
  updatePurchaseInvalidUser = 'User cannot update report created/modified by admin.',
  updatePurchasePastDue = 'The purchase report cannot be edited.',
  updatePurchaseInvalidReportId = 'The purchase report ID is invalid.',
  updatePurchaseReportDate = 'The purchase report date can be edited within a reporting period.',

  deletePurchaseNotAllowed = 'You are not allowed to remove this purchase report.',
  deletePurchaseInvalidUser = 'User cannot delete report created/modified by admin.',
  deletePurchasePastDue = 'The purchase report cannot be deleted.',
  deletePurchaseInvalidReportId = 'The purchase report ID is invalid.',

  inactiveDealer = 'Your license was inactive on the provided purchase date.',

  speciesNotFound = 'The chosen species does not exist.',
  sellerNotExists = 'This seller\'s Commercial Marine License doesn\'t exist.',
  commentTooLong = 'Comment is too long. ',
  fitInto = 'is too long.',
  lessThan = 'Provided value is outside of allowed range.'
}

export namespace httpValidationErrorMessages {
  export function getMessage(error: any) {
    switch (error.code) {
      case httpValidationErrorCodes.required:
      case httpValidationErrorCodes.fitInto:
        return `${error.field} ${this[error.code]}`;

      default:
        return error.defaultMessage || this[error.code] || `${unknownError}${error.code}`;
    }
  }
}
